import { useCallback } from "react";
import { Filters, Searches, Sort } from "../models/shipeezi.table";

export type HandlesGridType = {
  setSorting?: (value?: Array<string[]>) => void;
  setPage?: (value: number) => void;
  setPageSize?: (value: number) => void;
  setFilters?: (value: Filters) => void;
  setSearches?: (value: Searches) => void;
};

export const handlesGrid = ({
  setSorting,
  setSearches,
  setPage,
  setFilters,
  setPageSize,
}: HandlesGridType) => {
  const handleSort = useCallback((sorts?: Sort[]) => {
    const sorting: Array<string[]> = [];

    if (sorts && sorts?.length > 0) {
      sorts.forEach((sort) => {
        if (sort?.columnToSorting) {
          sorting.push([sort.columnName, sort?.columnToSorting, sort.direction]);
        } else {
          sorting.push([sort.columnName, sort.direction]);
        }
      });
    }

    if (setSorting) setSorting(sorting);

    return sorting;
  }, []);

  const handleCurrentPage = useCallback((numberOfPage: number) => {
    const numberOfPageMinusOne = numberOfPage > 0 ? numberOfPage - 1 : 0;

    if (setPage) setPage(numberOfPageMinusOne);

    return numberOfPageMinusOne;
  }, []);

  const handlePageSize = useCallback((pageSize: number) => {
    if (setPageSize) setPageSize(pageSize);

    return pageSize;
  }, []);

  const handleFilter = useCallback((value: Filters) => {
    if (setFilters) setFilters(value);
    if (setPage) setPage(0);

    return value;
  }, [setFilters, setPage]);

  const handleSearch = useCallback((values: Searches) => {
    if (setSearches) setSearches(values);
    if (setPage) setPage(0);

    return values;
  }, [setSearches, setPage]);

  return {
    handleSort,
    handleCurrentPage,
    handlePageSize,
    handleFilter,
    handleSearch,
  };
};
